import React, {CSSProperties} from 'react';
import {Location} from "../../types/location";
import {MapListItem} from "../Ui/MapListItem";
import {Mode} from "../../enum/mode";

type MapListProps = {
    locations: Location[],
    mapHoverLocation: Location | null,
    mapSelectLocation: Location | null,
    mode: Mode
}

export function MapList({locations, mapHoverLocation, mapSelectLocation, mode} : MapListProps) {

    const selectedStyle : CSSProperties = {
        backgroundColor: '#f6f6f6',
        transition: 'all .3s ease'
    };

    const isSelected = (location: Location): boolean => {
        if(mode === Mode.SINGLE) {
            return false;
        }

        return (mapHoverLocation !== null && location.uid === mapHoverLocation.uid)
            || (mapSelectLocation !== null && location.uid === mapSelectLocation.uid);
    };

    return (
        <div className={`mapList ${mode !== Mode.SINGLE ? 'listFullMode' : 'listSingleMode' }`}>
            {locations && locations.map((location : Location) =>
                <div
                    style={isSelected(location) ? selectedStyle : undefined}
                    className={'maplistElement'}
                    key={location.uid}

                >
                    <MapListItem location={location} mode={mode}/>
                </div>)
            }
        </div>
    );
}
